import React, { useState, useCallback, useEffect, useRef } from 'react';
import { RefreshCw, Save, Home, Eye, ChevronLeft, ChevronRight } from 'lucide-react';
import { useLocation, useNavigate } from "react-router-dom";
import useApiGetPost from "../hooks/useApiGetPost";
import axios from 'axios';
import { Alert, Box, Snackbar } from "@mui/material";

import useApi from "../hooks/useApi";

import {
  CircularProgress,
  Autocomplete,
  TextField,
} from "@mui/material";

// --- START: SIDEBAR & RIGHTS IMPORTS ---
import AllDoSidebar from "../components/salesInvoice/AllDoSidebar";
import ReuseSidebar from "../components/salesInvoice/ReuseSidebar";
import GenericComponent from "../components/salesInvoice/GenericComponent";
import canUserSeeThis from "../components/common/CheckCanUserSeeThis";
// --- END: SIDEBAR & RIGHTS IMPORTS ---

export default function PriceManager() {
  const navigate = useNavigate();

  const {
    loading: loadinggetSubCategory,
    data: datagetSubCategory,
    get: getSubCategory,
  } = useApiGetPost();
  const {
    loading: loadinggetCategory,
    data: datagetCategory,
    get: getCategory,
  } = useApiGetPost();
  const {
    loading: loadinggetSubgroup,
    data: datagetSubgroup,
    get: getSubgroup,
  } = useApiGetPost();
  const {
    loading: loadinggetgroup,
    data: datagetgroup,
    get: getgroup,
  } = useApiGetPost();

  const [partsList, setPartsList] = useState([]);

  // Filters
  const [group, setGroup] = useState("-");
  const [sgroup, setSgroup] = useState("-");
  const [category, setCategory] = useState("-");
  const [scategory, setScategory] = useState("-");
  const [searchText, setSearchText] = useState("-");
  const [searchInputValue, setSearchInputValue] = useState("");

  const [refreshingStock, setRefreshingStock] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Pagination
  const [pagePartsList, setPagePartsList] = useState(1);
  const pageSizePartsList = 50;

  // Loading
  const [loadingPartsList, setLoadingPartsList] = useState(false);
  const debounceTimerRef = useRef(null);

  const {
    loading: loadingPurchaseHistory,
    data: dataPurchaseHistory,
    get: getPurchaseHistory,
  } = useApiGetPost();

  const {
    loading: loadingSubstituteList,
    data: dataSubstituteList,
    get: getSubstituteList,
  } = useApiGetPost();

  const {
    loading: loadingGetPriceList,
    data: dataGetPriceList,
    get: getPriceList,
  } = useApiGetPost();

  const currentDepartment = localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const COMPANY_CODE = localStorage.getItem("companyCode");
  let API_PATHS = localStorage.getItem("apiPaths") ? JSON.parse(localStorage.getItem("apiPaths")) : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

  // Selection state tracking complete object structures
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [autoRefresh, setAutoRefresh] = useState(true);

  // --- SIDEBAR STATE SYSTEM ---
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeComponent, setActiveComponent] = useState(null);

  // --- MODE MAP SYNCHRONIZED TO THE REVISED CONFIGURATION ---
  const modeMap = {
    AllTransactions: "All_Transactions",
    DeliveryOrder: "Dorder",
    SalesOrder: "Sorder",
    OrderRequest: "Orderreq",
    Sales: "Sales",
    Purchase: "Purchase",
    QuotationHistory: "Quot_Track", // Map to your tracking history view component
    Itemdetails: "ItemDetails",
  };




  // --- EXACT ACTIVE BUTTONS COPIED FROM ProductsModalActionButtons.js ---
  const buttons = [
    {
      id: "f1",
      component: "SalesOrder",
      label: "Sales Order Pending",
      fullLabel: "Sales Order Pending",
      button: "F1",
    },
    {
      id: "f2",
      component: "DeliveryOrder",
      label: "Delivery Order Pending",
      fullLabel: "Delivery Order Pending",
      button: "F2",
    },
    {
      id: "f3",
      component: "Itemdetails",
      label: "Item details with modification",
      fullLabel: "Item details with modification",
      button: "F3",
    },
    {
      id: "f4",
      component: "OrderRequest",
      label: "Order request",
      fullLabel: "Order Request",
      button: "F4",
    },
    {
      id: "f7",
      component: "Sales",
      label: "Sales History",
      fullLabel: "Sales History",
      button: "F7",
    },
    {
      id: "f8",
      component: "Purchase",
      label: "Purchase History",
      fullLabel: "Purchase History",
      button: "F8",
    },
    {
      id: "f9",
      component: "AllTransactions",
      label: "Complete Transaction History",
      fullLabel: "Complete Transaction History",
      button: "F9",
    },
    {
      id: "f11",
      component: "QuotationHistory",
      label: "Quotation History",
      fullLabel: "Quotation History",
      button: "F11",
    },
  ];

  // --- EXACT ACTIVE ACCESS KEYS MAP COPIED FROM ProductsModalActionButtons.js ---
  const accessKeyAndFunctionKeyMap = {
    F1: "",
    F2: "JT",
    F4: "JS",
    F7: "JO",
    F8: "JN",
    F9: "JV",
    F11: "JU",
  };

  const initialInputValues = {
    previousCostAvg: 0,
    newCostAvg: 0,
    prevSellingPrice1Input: 0,
    prevSellingPrice1Percent: 0,
    prevSellingPrice2Input: 0,
    prevSellingPrice2Percent: 0,
    prevSellingPrice3Input: 0,
    prevSellingPrice3Percent: 0,
    sellingPrice1Percent: 0,
    sellingPrice1Input: 0,
    sellingPrice1Calculated: 0,
    sellingPrice2Percent: 0,
    sellingPrice2Input: 0,
    sellingPrice2Calculated: 0,
    sellingPrice3Percent: 0,
    sellingPrice3Input: 0,
    sellingPrice3Calculated: 0,
    maxQtyAExtra: 0,
    maxQtyAThreshold: 0,
    maxQtyBExtra: 0,
    maxQtyBThreshold: 0,
  }


  const [inputValues, setInputValues] = useState(initialInputValues);

  const handleInputChange = (field, value) => {
    setInputValues(prev => ({ ...prev, [field]: value }));
  };

  const populatePriceDataFromAPI = (apiData) => {
    if (!apiData || apiData.length === 0) return;

    const data = apiData[0];
    const previousCost = parseFloat(data.previouscost) || 0;
    const price1 = parseFloat(data.price_unit) || 0;
    const price2 = parseFloat(data.price2) || 0;
    const price3 = parseFloat(data.price3) || 0;
    const nextCost = parseFloat(data.nextcostprice) || 0;

    const calcPercent = (price, cost) => {
      if (cost === 0) return 0;
      return (((price - cost) / cost) * 100).toFixed(2);
    };

    const percent1 = calcPercent(price1, previousCost);
    const percent2 = calcPercent(price2, previousCost);
    const percent3 = calcPercent(price3, previousCost);

    const newPercent1 = calcPercent(price1, nextCost);
    const newPercent2 = calcPercent(price2, nextCost);
    const newPercent3 = calcPercent(price3, nextCost);

    setInputValues((prev) => ({
      ...prev,
      previousCostAvg: previousCost.toFixed(3),
      newCostAvg: nextCost.toFixed(3),
      prevSellingPrice1Input: price1.toFixed(2),
      prevSellingPrice1Percent: percent1,
      prevSellingPrice2Input: price2.toFixed(2),
      prevSellingPrice2Percent: percent2,
      prevSellingPrice3Input: price3.toFixed(2),
      prevSellingPrice3Percent: percent3,
      sellingPrice1Input: price1.toFixed(2),
      sellingPrice2Input: price2.toFixed(2),
      sellingPrice3Input: price3.toFixed(2),
      sellingPrice1Percent: newPercent1,
      sellingPrice2Percent: newPercent2,
      sellingPrice3Percent: newPercent3,
      sellingPrice1Calculated: newPercent1,
      sellingPrice2Calculated: newPercent2,
      sellingPrice3Calculated: newPercent3,
      maxQtyAExtra: parseFloat(data.issd09) || 0,
      maxQtyAThreshold: parseFloat(data.rcvd09) || 0,
      maxQtyBExtra: parseFloat(data.issd08) || 0,
      maxQtyBThreshold: parseFloat(data.rcvd08) || 0,
    }));
  };

  const handleSave = async () => {
    if (!selectedProduct?.Code) {
      alert("Please select a part from the list first before saving.");
      return;
    }

    const payload = [
      {
        "CmpCode": COMPANY_CODE,
        "code": selectedProduct.Code,
        "rcvd09": parseFloat(inputValues.maxQtyAThreshold) || 0,
        "issd09": parseFloat(inputValues.maxQtyAExtra) || 0,
        "rcvd08": parseFloat(inputValues.maxQtyBThreshold) || 0,
        "issd08": parseFloat(inputValues.maxQtyBExtra) || 0,
        "packprice1": parseFloat(inputValues.previousCostAvg) || 0,
        "qty2": parseFloat(inputValues.newCostAvg) || 0,
        "price_unit": parseFloat(inputValues.sellingPrice1Input) || 0,
        "price2": parseFloat(inputValues.sellingPrice2Input) || 0,
        "price3": parseFloat(inputValues.sellingPrice3Input) || 0
      }
    ];

    try {
      const saveApiUrl = `${BASE_URL}/api/CRMPriceManager`;
      const response = await axios.post(saveApiUrl, payload);
      if (response.data.result?.trim()?.toUpperCase() === "SAVED") {
        alert("Prices successfully updated");
        setInputValues(initialInputValues);
        getPartsList();
      }
    } catch (error) {
      console.error("An error occurred while uploading updated pricing matrix logs:", error);
      alert("Failed to update pricing records. Check network configurations.");
    }
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleStockRefresh = async () => {
    if (!COMPANY_CODE) {
      showSnackbar("Company code missing", "error");
      return;
    }
    setRefreshingStock(true);
    try {
      const response = await fetch(`${BASE_URL}/api/CRMStockRefresh/${COMPANY_CODE}`, { method: "GET" });
      if (!response.ok) throw new Error("Request failed");
      const result = await response.json();
      if (Array.isArray(result) && result[0]?.Column1 === "DONE") {
        showSnackbar("Refreshed successfully", "success");
        getPartsList();
      } else {
        showSnackbar(`Refresh failed: ${result[0]?.Column1 || "Unknown response"}`, "warning");
      }
    } catch (error) {
      console.error(error);
      showSnackbar("Refresh aborted or network error ", "error");
    } finally {
      setRefreshingStock(false);
    }
  };

  // --- CORE DISPATCHER HANDLING CLICKS & SHORTCUTS ---
  const handleFunctionKeyAction = useCallback((keyName) => {



    const accessKey = accessKeyAndFunctionKeyMap[keyName];
    const hasAccess = accessKey === "" ? true : accessKey ? canUserSeeThis(accessKey) : true;

    if (!hasAccess) {
      console.log("No authorization privileges to view this section.");
      return;
    }

    const buttonConfig = buttons.find(b => b.button === keyName);
    if (buttonConfig) {
      setActiveComponent(buttonConfig);
      setSidebarOpen(true);
    }
  }, [selectedProduct, buttons]);

  // Keyboard Hooks
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key.startsWith("F") && event.key.length > 1 && selectedProduct?.Code) {

        console.log("keyName", event.key)

        event.preventDefault();

        if (!selectedProduct?.Code) {
          showSnackbar("Please select a product code from the table list first.", "warning");
          return;
        }

        if (event.key === "F3") {
          if (canUserSeeThis("AE")) {


            navigate("/itemCreation", { state: selectedProduct?.Code });
            return;
          } else {
            console.log("no access");
            return;
          }
        }

        const accessKey = accessKeyAndFunctionKeyMap[event.key];
        if (accessKey !== undefined) {
          const hasAccess = accessKey === "" ? true : accessKey ? canUserSeeThis(accessKey) : true;
          if (hasAccess) {
            event.preventDefault();
            handleFunctionKeyAction(event.key);
          }
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedProduct, handleFunctionKeyAction]);

  const getPartsList = async () => {
    try {
      setLoadingPartsList(true);
      const encoded_group = encodeURIComponent(group);
      const encoded_sgroup = encodeURIComponent(sgroup);
      const encoded_category = encodeURIComponent(category);
      const encoded_scategory = encodeURIComponent(scategory);
      const encoded_searchText = encodeURIComponent(searchText);

      const apiUrl = `${BASE_URL}/api/CRMStockreport/${COMPANY_CODE}/pricemanager/2026-01-01/${encoded_group}/${encoded_sgroup}/${encoded_category}/${encoded_scategory}/${encoded_searchText}/-/${pagePartsList}/${pageSizePartsList}`;
      const response = await axios.get(apiUrl);
      setPartsList(response.data || []);
    } catch (error) {
      console.log("API Error:", error);
    } finally {
      setLoadingPartsList(false);
    }
  };

  useEffect(() => {
    getPartsList();
  }, [group, sgroup, category, scategory, searchText, pagePartsList]);

  const debouncedSearch = useCallback((value) => {
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = setTimeout(() => {
      const searchValue = value.trim() === "" ? "-" : value;
      setSearchText(searchValue);
      setPagePartsList(1);
    }, 500);
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInputValue(value);
    debouncedSearch(value);
  };

  useEffect(() => {
    if (selectedProduct?.Code) {
      const partCode = selectedProduct.Code;

      const url = `${BASE_URL}/api/CRMItemTransHistory/${COMPANY_CODE}/Purchase/${partCode}/${currentDepartment}/-/-`;
      getPurchaseHistory(url);

      const urlSubstitute = `${BASE_URL}/api/CRMStockList/${COMPANY_CODE}/GETSUBSTITUTES/${partCode}/-/-`;
      getSubstituteList(urlSubstitute);

      const urlPriceList = `${BASE_URL}/api/CRMStockList/${COMPANY_CODE}/PRICELIST/${partCode}/-/-`;
      getPriceList(urlPriceList);
    }
  }, [selectedProduct]);

  useEffect(() => {
    getCategory(`${BASE_URL}/api/mastercount/${COMPANY_CODE}/category/-/-`);
    getSubCategory(`${BASE_URL}/api/mastercount/${COMPANY_CODE}/subcategory/-/-`);
    getgroup(`${BASE_URL}/api/mastercount/${COMPANY_CODE}/group/-/-`);
    getSubgroup(`${BASE_URL}/api/mastercount/${COMPANY_CODE}/subgroup/-/-`);

    return () => {
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    };
  }, []);

  useEffect(() => {
    if (dataGetPriceList) {
      populatePriceDataFromAPI(dataGetPriceList);
    }
  }, [dataGetPriceList]);

  // const renderSidebarContent = () => {
  //   if (!activeComponent) return null;
  //   const mode = modeMap[activeComponent.component];
  //   return (
  //     <AllDoSidebar
  //       selectedProduct={selectedProduct}
  //       mode={mode}
  //       exportFileName={activeComponent?.fullLabel}
  //     />
  //   );
  // };

  const renderSidebarContent = () => {
    if (!activeComponent) return null;

    const mode = modeMap[activeComponent.component];
    const componentProps = { selectedProduct, mode };

    switch (activeComponent.component) {
      case "DeliveryOrder":
      case "PendingOrder":
      case "SalesOrder":
      case "Sales":
      case "SalesmanRequest":
      case "Purchase":
      case "AllTransactions":
      case "Transit":
      case "QuotationTrack":
      case "Quotations":
      case "OrderRequest":
      case "Claim":
        return (
          <AllDoSidebar
            {...componentProps}
            exportFileName={activeComponent?.fullLabel}
          />
        );
      default:
        return (
          <GenericComponent title={activeComponent.label} {...componentProps} />
        );
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-8">
      {/* Header Section */}
      <div className="mb-2">
        <div className="flex items-center justify-between mb-2">
          <div>
            <h1 className="text-xl font-bold text-slate-900 mb-2 tracking-tight">
              PRICE MANAGER
            </h1>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-slate-600">AUTO REFRESH</span>
              <button
                onClick={() => setAutoRefresh(!autoRefresh)}
                className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors ${autoRefresh ? 'bg-blue-600' : 'bg-slate-300'}`}
              >
                <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${autoRefresh ? 'translate-x-6' : 'translate-x-1'}`} />
              </button>
              <span className="text-sm font-medium text-slate-600 min-w-8">
                {autoRefresh ? 'On' : 'Off'}
              </span>
            </div>
          </div>
        </div>

        {/* Filter Row */}
        <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-4 flex flex-wrap gap-3">
          <span className="text-red-600 font-bold text-sm">Filter &gt;&gt;</span>
          <input
            type="text"
            placeholder="Search"
            value={searchInputValue}
            onChange={handleSearchChange}
            className="px-4 py-2 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-green-400"
          />

          <div className="w-48">
            <Autocomplete
              options={datagetgroup || []}
              getOptionLabel={(option) => option?.DESCRIPTION || ""}
              loading={loadinggetgroup}
              value={datagetgroup?.find((g) => g["GRP CODE"] === group) || null}
              onChange={(e, newValue) => setGroup(newValue ? newValue["GRP CODE"] : "-")}
              renderInput={(params) => (
                <TextField {...params} label="Select Group" size="small" />
              )}
            />
          </div>

          <div className="w-48">
            <Autocomplete
              options={datagetSubgroup || []}
              getOptionLabel={(option) => option?.DESCRIPTION || ""}
              loading={loadinggetSubgroup}
              value={datagetSubgroup?.find((g) => g["GRP CODE"] === sgroup) || null}
              onChange={(e, newValue) => setSgroup(newValue ? newValue["GRP CODE"] : "-")}
              renderInput={(params) => (
                <TextField {...params} label="Select SubGroup" size="small" />
              )}
            />
          </div>

          <div className="w-48">
            <Autocomplete
              options={datagetCategory || []}
              getOptionLabel={(option) => option?.DESCRIPTION || ""}
              loading={loadinggetCategory}
              value={datagetCategory?.find((g) => g["GRP CODE"] === category) || null}
              onChange={(e, newValue) => setCategory(newValue ? newValue["GRP CODE"] : "-")}
              renderInput={(params) => (
                <TextField {...params} label="Select Category" size="small" />
              )}
            />
          </div>

          <div className="w-48">
            <Autocomplete
              options={datagetSubCategory || []}
              getOptionLabel={(option) => option?.DESCRIPTION || ""}
              loading={loadinggetSubCategory}
              value={datagetSubCategory?.find((g) => g["GRP CODE"] === scategory) || null}
              onChange={(e, newValue) => setScategory(newValue ? newValue["GRP CODE"] : "-")}
              renderInput={(params) => (
                <TextField {...params} label="Select SubCategory" size="small" />
              )}
            />
          </div>
          <button className="ml-auto px-6 py-2 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-800 transition-colors text-sm">
            EXPORT
          </button>
        </div>
      </div>

      {/* Parts Table */}
      <div className="space-y-4">
        <div className="bg-white rounded-lg shadow-md border border-slate-200 overflow-hidden">
          <div className="overflow-x-auto max-h-32 relative border border-slate-200 rounded-lg">
            <table className="w-full text-left border-collapse table-fixed min-w-[2000px]">
              <thead className="sticky top-0 bg-slate-50 z-10 shadow-sm">
                <tr className="divide-x divide-slate-200">
                  <th className="w-16 px-4 py-3 text-[10px] font-bold text-slate-500 uppercase border-b border-slate-200">S.N</th>
                  <th className="w-40 px-4 py-3 text-[10px] font-bold text-slate-500 uppercase border-b border-slate-200">Code</th>
                  <th className="w-96 px-4 py-3 text-[10px] font-bold text-slate-500 uppercase border-b border-slate-200">Description</th>
                  <th className="w-20 px-4 py-3 text-[10px] font-bold text-slate-500 uppercase border-b border-slate-200 text-center">Unit</th>
                  <th className="w-24 px-4 py-3 text-[10px] font-bold text-slate-500 uppercase border-b border-slate-200 text-center">Avl Qty</th>
                  <th className="w-32 px-4 py-3 text-[10px] font-bold text-slate-500 uppercase border-b border-slate-200">Brand</th>
                  <th className="w-32 px-4 py-3 text-[10px] font-bold text-slate-500 uppercase border-b border-slate-200">Category</th>
                  <th className="w-32 px-4 py-3 text-[10px] font-bold text-slate-500 uppercase border-b border-slate-200">Vehicle</th>
                  <th className="w-24 px-4 py-3 text-[10px] font-bold text-orange-600 uppercase border-b border-slate-200 text-center">PO Pend</th>
                  <th className="w-48 px-4 py-3 text-[10px] font-bold text-slate-500 uppercase border-b border-slate-200">Last Supplier</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {loadingPartsList ? (
                  <tr>
                    <td colSpan="10" className="px-4 py-12 text-center">
                      <div className="flex flex-col items-center gap-2">
                        <RefreshCw size={24} className="text-blue-500 animate-spin" />
                        <span className="text-slate-400 text-xs font-medium">Loading inventory data...</span>
                      </div>
                    </td>
                  </tr>
                ) : partsList.length === 0 ? (
                  <tr>
                    <td colSpan="10" className="px-4 py-12 text-center text-slate-400 text-xs">No products found.</td>
                  </tr>
                ) : (
                  partsList.map((product, index) => (
                    <tr
                      key={product.Code || index}
                      onClick={() => setSelectedProduct({ ...product, id: product.Code })}
                      className={`group cursor-pointer transition-colors divide-x divide-slate-100 hover:bg-blue-50/50 ${selectedProduct?.Code === product.Code ? "bg-blue-50 border-l-4 border-l-blue-600" : ""}`}
                    >
                      <td className="px-4 py-2 text-[11px] text-center text-slate-600">{product["S.N."]}</td>
                      <td className="px-4 py-2 text-[11px] font-bold text-slate-700">{product.Code}</td>
                      <td className="px-4 py-2 text-[11px] text-slate-600 truncate">{product.Description}</td>
                      <td className="px-4 py-2 text-[11px] text-center text-slate-500">{product.Unit}</td>
                      <td className="px-4 py-2 text-[11px] text-center font-medium text-slate-700">{product.Available_Qy}</td>
                      <td className="px-4 py-2 text-[11px] text-slate-500">{product.Brand || "-"}</td>
                      <td className="px-4 py-2 text-[11px] text-slate-500">{product.Category || "-"}</td>
                      <td className="px-4 py-2 text-[11px] text-slate-500">{product.Vehicle || "-"}</td>
                      <td className="px-4 py-2 text-[11px] text-center text-orange-600 font-medium">{product.PO_PEnd}</td>
                      <td className="px-4 py-2 text-[11px] text-slate-500 truncate">{product["Last Supplier"] || "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          <div className="flex items-center justify-between px-4 py-2.5 bg-slate-50 border-t border-slate-200">
            <div className="flex items-center gap-2">
              <span className="text-xs text-slate-600 font-medium">Page <span className="text-slate-900 font-bold">{pagePartsList}</span></span>
            </div>
            <div className="flex items-center gap-1">
              <button
                onClick={() => setPagePartsList(prev => Math.max(prev - 1, 1))}
                disabled={pagePartsList === 1 || loadingPartsList}
                className="p-1.5 text-slate-700 bg-white border border-slate-300 rounded disabled:opacity-40"
              >
                <ChevronLeft size={16} />
              </button>
              <button
                onClick={() => setPagePartsList(prev => prev + 1)}
                disabled={partsList.length < pageSizePartsList || loadingPartsList}
                className="p-1.5 text-slate-700 bg-white border border-slate-300 rounded disabled:opacity-40"
              >
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        </div>

        {/* Price Update Block */}
        <div className="bg-white rounded-lg shadow-md border border-slate-200 overflow-hidden">
          <div className="bg-white px-6 py-1 border-b border-slate-200">
            <h3 className="text-slate-800 font-bold text-sm">PRICE UPDATE</h3>
          </div>
          <div className="p-4 space-y-4">
            <div className="flex flex-col lg:flex-row gap-4">
              {/* Previous Cost Layout */}
              <div className="w-full lg:w-[24%] lg:min-w-[280px] bg-slate-50/50 rounded-xl p-2 border border-slate-200 shadow-sm flex-shrink-0">
                <div className="space-y-1.5">
                  <div className="bg-white p-1.5 rounded-lg border border-slate-100 shadow-sm flex items-center justify-between gap-2">
                    <label className="text-slate-600 font-bold text-[10px] uppercase block leading-tight">Previous Cost Avg</label>
                    <div className="flex items-center gap-1">
                      <input type="text" value={inputValues.previousCostAvg} className="w-16 px-2 py-2 bg-slate-50 border border-slate-200 rounded text-[10px] text-center font-bold text-slate-500" readOnly />
                      <span className="text-slate-400 text-[10px] font-bold w-10 text-center">%</span>
                    </div>
                  </div>
                  {[1, 2, 3].map(i => (
                    <div key={`prev-${i}`} className="bg-white p-1.5 rounded-lg border border-slate-100 shadow-sm flex items-center justify-between gap-2">
                      <label className="text-slate-600 font-bold text-[10px] uppercase block">Previous Selling Price {i}</label>
                      <div className="flex items-center gap-1">
                        <input type="text" value={inputValues[`prevSellingPrice${i}Input`] || ''} className="w-16 px-2 py-2 border border-slate-300 rounded text-[10px] text-center" readOnly />
                        <input type="text" value={inputValues[`prevSellingPrice${i}Percent`] === 0 ? '' : inputValues[`prevSellingPrice${i}Percent`]} className="w-12 px-1 py-2 border border-slate-300 rounded text-[10px] text-center" readOnly />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Adjustments Entry Input Controls */}
              <div className="w-full lg:w-[32%] lg:min-w-[365px] bg-blue-50/10 rounded-xl p-2 border border-blue-100 shadow-sm flex-shrink-0">
                <div className="space-y-1.5">
                  <div className="bg-white p-1.5 rounded-lg border border-blue-100 shadow-sm flex items-center justify-between gap-2">
                    <label className="text-blue-600 font-bold text-[10px] uppercase block">New Cost Avg</label>
                    <div className="grid grid-cols-3 items-center gap-1">
                      <input type="text" value={inputValues.newCostAvg} className="w-16 px-2 py-2 border border-blue-200 rounded text-[10px] text-center font-bold text-blue-600" readOnly />
                      <div className="w-12 text-[10px] font-bold text-blue-600 text-center">%</div>
                      <div className="w-20 text-[10px] font-bold text-blue-600 text-center">% input</div>
                    </div>
                  </div>
                  {[1, 2, 3].map(i => (
                    <div key={`new-${i}`} className="bg-white p-1.5 rounded-lg border border-blue-100 shadow-sm flex items-center justify-between gap-2">
                      <label className="text-blue-600 font-bold text-[10px] uppercase block">New Selling Price {i}</label>
                      <div className="grid grid-cols-3 items-center gap-1">
                        <input
                          type="number"
                          value={inputValues[`sellingPrice${i}Input`]}
                          onChange={(e) => {
                            const newValue = parseFloat(e.target.value) || 0;
                            handleInputChange(`sellingPrice${i}Input`, e.target.value);
                            const newCost = parseFloat(inputValues.newCostAvg) || 0;
                            if (newCost !== 0) {
                              const calcPercent = (((newValue - newCost) / newCost) * 100).toFixed(2);
                              handleInputChange(`sellingPrice${i}Percent`, calcPercent);
                              handleInputChange(`sellingPrice${i}Calculated`, calcPercent);
                            }
                          }}
                          className="w-16 px-2 py-2 border border-blue-200 rounded text-[10px] text-center"
                        />
                        <input type="text" value={inputValues[`sellingPrice${i}Percent`]} className="w-16 px-1 py-2 bg-slate-50 border border-blue-200 rounded text-[10px] text-center" readOnly />
                        <input
                          type="number"
                          value={inputValues[`sellingPrice${i}Calculated`] || ''}
                          onChange={(e) => {
                            const percentValue = parseFloat(e.target.value) || 0;
                            handleInputChange(`sellingPrice${i}Calculated`, e.target.value);
                            const newCost = parseFloat(inputValues.newCostAvg) || 0;
                            const computedPrice = newCost + (newCost * percentValue) / 100;
                            handleInputChange(`sellingPrice${i}Input`, computedPrice.toFixed(2));
                            handleInputChange(`sellingPrice${i}Percent`, percentValue.toFixed(2));
                          }}
                          className="w-20 px-2 py-2 border border-blue-200 rounded text-[10px] text-center font-bold text-blue-800"
                        />
                      </div>
                    </div>
                  ))}

                  <div className="bg-slate-50 p-2 rounded-lg border border-slate-200 flex items-center justify-between gap-2 shadow-sm">
                    <label className="text-slate-700 font-bold text-[10px] uppercase block leading-tight max-w-[100px]">Max Qty - A</label>
                    <div className="flex items-center gap-1 flex-shrink-0">
                      <div className="grid grid-cols-3 items-center gap-1">
                        <div className="w-16 flex justify-center">
                          <input
                            type="text"
                            value={inputValues.maxQtyAThreshold || ''}
                            onChange={(e) => handleInputChange('maxQtyAThreshold', e.target.value)}
                            className="w-16 px-2 py-2 border border-slate-300 rounded text-[10px] text-center font-bold focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all shadow-sm"
                            placeholder="Qty"
                          />
                        </div>
                        <div className="w-12 text-[10px] font-bold text-slate-400 uppercase text-center">Extra Disc %</div>
                        <div className="w-20 flex justify-center">
                          <input
                            type="text"
                            value={inputValues.maxQtyAExtra}
                            onChange={(e) => handleInputChange('maxQtyAExtra', e.target.value)}
                            className="w-20 px-2 py-2 border border-slate-300 rounded text-[10px] text-center font-bold focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all shadow-sm"
                            placeholder="%"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-slate-50 p-2 rounded-lg border border-slate-200 flex items-center justify-between gap-2 shadow-sm">
                    <label className="text-slate-700 font-bold text-[10px] uppercase block leading-tight max-w-[100px]">Max Qty - B</label>
                    <div className="flex items-center gap-1 flex-shrink-0">
                      <div className="grid grid-cols-3 items-center gap-1">
                        <div className="w-16 flex justify-center">
                          <input
                            type="text"
                            value={inputValues.maxQtyBThreshold || ''}
                            onChange={(e) => handleInputChange('maxQtyBThreshold', e.target.value)}
                            className="w-16 px-2 py-2 border border-slate-300 rounded text-[10px] text-center font-bold focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all shadow-sm"
                            placeholder="Qty"
                          />
                        </div>
                        <div className="w-12 text-[10px] font-bold text-slate-400 uppercase text-center">Extra Disc %</div>
                        <div className="w-20 flex justify-center">
                          <input
                            type="text"
                            value={inputValues.maxQtyBExtra}
                            onChange={(e) => handleInputChange('maxQtyBExtra', e.target.value)}
                            className="w-20 px-2 py-2 border border-slate-300 rounded text-[10px] text-center font-bold focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all shadow-sm"
                            placeholder="%"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              {/* Purchase History Grid */}
              <div className="flex-1 space-y-6 min-w-0">
                <div className="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden h-[200px] flex flex-col">
                  <div className="bg-white px-6 py-2 border-b border-slate-100 flex-shrink-0">
                    <h4 className="text-slate-700 font-bold text-sm uppercase">Purchase History</h4>
                  </div>
                  {loadingPurchaseHistory ? (
                    <div className="px-4 flex-1 text-center flex items-center justify-center"><RefreshCw className="animate-spin" /></div>
                  ) : (
                    <div className="flex-1 overflow-y-auto border-t border-slate-100">
                      <table className="w-full text-left border-collapse table-fixed min-w-[100px]">
                        <thead className="sticky top-0 bg-slate-50 z-10">
                          <tr className="divide-x divide-slate-100 text-[11px] text-slate-500">
                            <th className="w-24 px-3 py-2">Date</th>
                            <th className="w-20 px-3 py-2 text-center">Dept</th>
                            <th className="w-16 px-3 py-2 text-center">Locn</th>
                            <th className="w-24 px-3 py-2">Srv</th>
                            <th className="w-48 px-3 py-2">Supplier</th>
                            <th className="w-32 px-3 py-2">Inv No</th>
                            <th className="w-20 px-3 py-2 text-center">Qty</th>
                            <th className="w-28 px-3 py-2 text-right">Land Cost</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50 text-[11px] text-slate-600">
                          {dataPurchaseHistory?.map((item, idx) => (
                            <tr key={idx} className="hover:bg-slate-50 divide-x divide-slate-50">
                              <td className="px-3 py-1.5">{item.DATE ? new Date(item.DATE).toLocaleDateString() : '-'}</td>
                              <td className="px-3 py-1.5 text-center">{item.Deptno}</td>
                              <td className="px-3 py-1.5 text-center">{item.Locn}</td>
                              <td className="px-3 py-1.5 font-medium">{item.Srv}</td>
                              <td className="px-3 py-1.5 truncate">{item.Supplier}</td>
                              <td className="px-3 py-1.5">{item.Supp_Inv || '-'}</td>
                              <td className="px-3 py-1.5 text-center font-medium">{item.Qty}</td>
                              <td className="px-3 py-1.5 text-right text-blue-600 font-bold">{Number(item.Land_Cost || 0).toFixed(3)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {/* Substitutes Section */}
                <div className="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden">
                  <div className="bg-white px-6 py-3 border-b border-slate-100">
                    <h4 className="text-slate-700 font-bold text-sm uppercase tracking-wide">Substitutes</h4>
                  </div>
                  {loadingSubstituteList ? (
                    <div className="px-4 py-8 text-center min-h-32 flex flex-col items-center justify-center gap-2">
                      <RefreshCw size={16} className="text-blue-500 animate-spin" />
                      <span className="text-slate-400 text-[11px]">Loading substitutes...</span>
                    </div>
                  ) : !dataSubstituteList || dataSubstituteList.length === 0 ? (
                    <div className="px-4 py-8 text-center min-h-32 flex items-center justify-center text-slate-400 text-[11px]">
                      No substitutes available
                    </div>
                  ) : (
                    <div className="overflow-x-auto max-h-64 relative border border-slate-100 rounded-md">
                      <table className="w-full text-left border-collapse table-fixed">
                        <thead className="sticky top-0 bg-slate-50 z-10 shadow-sm">
                          <tr className="divide-x divide-slate-100">
                            <th className="w-24 px-3 py-2 text-[11px] font-bold text-slate-500 uppercase border-b border-slate-200 text-center">Substitute</th>
                            <th className="w-28 px-3 py-2 text-[11px] font-bold text-slate-500 uppercase border-b border-slate-200 text-right">Price</th>
                            <th className="w-28 px-3 py-2 text-[11px] font-bold text-slate-500 uppercase border-b border-slate-200 text-center">Qty</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50">
                          {dataSubstituteList.map((item, idx) => (
                            <tr key={idx} className="hover:bg-slate-50/50 transition-colors divide-x divide-slate-50">
                              <td className="px-3 py-1.5 text-[11px] text-center text-slate-500">
                                {item.Substitutes}
                              </td>
                              <td className="px-3 py-1.5 text-[11px] text-right font-mono text-slate-600">
                                {item.Price !== null && item.Price !== undefined
                                  ? Number(item.Price).toLocaleString(undefined, { minimumFractionDigits: 2 })
                                  : '-'}
                              </td>
                              <td className="px-3 py-1.5 text-[11px] text-center font-medium text-slate-700">
                                {item.Qty !== null && item.Qty !== undefined ? item.Qty : (item.Available_Qy || item.AVAL_QTY || 0)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* Action Controls Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <button

            className="bg-blue-600 text-white font-bold py-4 rounded-lg hover:bg-blue-800 transition-all flex items-center justify-center gap-2"
          >
            <Eye size={20} />
            <span className="text-[10px]">ITEM DETAILS</span>
          </button>
          <button
            onClick={handleStockRefresh}
            disabled={refreshingStock}
            className={`font-bold py-4 rounded-lg text-white transition-all flex items-center justify-center gap-2 ${refreshingStock ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-800"}`}
          >
            <RefreshCw size={20} className={refreshingStock ? "animate-spin" : ""} />
            <span className="text-[10px]">{refreshingStock ? "REFRESHING..." : "REFRESH"}</span>
          </button>
          <button
            onClick={handleSave}
            className="bg-blue-600 text-white font-bold py-4 rounded-lg hover:bg-blue-800 transition-all flex items-center justify-center gap-2"
          >
            <Save size={20} />
            <span className="text-[10px]">SAVE</span>
          </button>
          <button className="bg-blue-600 text-white font-bold py-4 rounded-lg hover:bg-blue-800 transition-all flex items-center justify-center gap-2">
            <Home size={20} />
            <span className="text-[10px]">EXIT</span>
          </button>
        </div>
      </div>

      {/* --- RE-STRUCTURED FUNCTION ACTION BUTTON BAR --- */}
      <div className="mt-8 bg-slate-100 rounded-lg shadow border border-slate-200 overflow-hidden">
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 divide-x divide-slate-200 bg-white">
          {buttons.map((btn) => {
            const accessKey = accessKeyAndFunctionKeyMap[btn.button];
            const hasAccess = accessKey === "" ? true : accessKey ? canUserSeeThis(accessKey) : true;
            const isDisabled = !hasAccess;

            return (
              <button
                key={btn.id}
                disabled={isDisabled}
                onClick={() => handleFunctionKeyAction(btn.button)}
                className={`px-2 py-3 text-[11px] font-semibold transition-colors text-center flex flex-col items-center justify-center border-b border-slate-100 group
                  ${isDisabled
                    ? "text-gray-400 bg-gray-50 cursor-not-allowed opacity-50"
                    : "text-slate-700 hover:bg-slate-50 cursor-pointer"
                  }
                `}
              >
                <span className={`bg-blue-600 text-white px-1.5 py-0.5 rounded text-xs font-bold mb-1 ${isDisabled ? "opacity-30 bg-gray-400" : ""}`}>
                  {btn.button}
                </span>
                <div className="text-[10px] font-medium truncate max-w-full px-1">
                  {btn.fullLabel}
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Unified Sidebars Integration */}
      <ReuseSidebar
        isOpen={sidebarOpen}
        onClose={() => {
          setSidebarOpen(false);
          setActiveComponent(null);
        }}
        title={activeComponent?.fullLabel || activeComponent?.label || "Details"}
        button={activeComponent?.button || ""}
        selectedProduct={selectedProduct}
        width={1000}
      >
        {renderSidebarContent()}
      </ReuseSidebar>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}